import { render, staticRenderFns } from "./TotalpaydetailReportDetail.vue?vue&type=template&id=92a6fade"
import script from "./TotalpaydetailReportDetail.vue?vue&type=script&lang=js"
export * from "./TotalpaydetailReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports